import { getLocale } from 'i18n/locale';
import { ELocale } from 'i18n/localeEnum';

export const showKilometres = ![ELocale.EN_US, ELocale.FR_FR, ELocale.SV_SE, ELocale.NN_NO, ELocale.EN_GB].includes(getLocale() as ELocale);
